var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-tracker',{ref:"actionTracker",attrs:{"items":_vm.items,"is_loading":_vm.is_loading,"is_saving":_vm.is_saving},on:{"save":_vm.handleSave,"update":_vm.handleUpdate}})}
var staticRenderFns = []

export { render, staticRenderFns }